// extracted by mini-css-extract-plugin
export default {"app":"App_app__Oec13","app__content":"App_app__content__cOvbF","app__loader":"App_app__loader__1M75l"};